import { FC, useEffect } from 'react';
import WithMobileSize from '../../../../../common/mobile-size/mobile-size';
import ROUTES from '../../../../../constants/routes';
import session from '../../../../../utils/session';
import InteractiveMenuContent from './components/interactive-menu-content/interactive-menu-content';
import './interactive-menu.scss';

type InteractiveMenuProps = TranslationProps & {
    mobile: boolean;
};
const InteractiveMenu: FC<InteractiveMenuProps> = ({ mobile }) => {
    // TODO: add logic for badge

    const amount = 0;
    const empty = true;

    useEffect(() => {
        if (!session.isLoggedIn()) {
            window.storage.removeItem('isSeller');
        }
    }, []);

    return (
        <div className='interactive-menu d-flex align-items-center justify-content-center'>
            <a className='link-inherit' href={ROUTES.NEW_INTERACTIVE_MATERIALS.path}>
                <InteractiveMenuContent amount={amount} empty={empty} />
            </a>
        </div>
    );
};

export default WithMobileSize(InteractiveMenu);
